import { Details } from '@/domain/mitarbeiter/features/rotationsplan/features/Details/Details';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

export function Page() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('domain.mitarbeiter.rotationsplan.title')}</title>
      </Helmet>
      <div className="flex-col gap-8 p-4 w-screen lg:p-10 2xl:max-w-screen-2xl 2xl:mx-auto">
        <Details />
        <Outlet />
      </div>
    </>
  );
}
